import { render, staticRenderFns } from "./DiscountField.vue?vue&type=template&id=12f92217"
import script from "./DiscountField.vue?vue&type=script&lang=js"
export * from "./DiscountField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports